module.exports = __webpack_public_path__ + "static/media/DuplicateSans-Heavy.4b10796e.woff";